import React from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBListGroup,
  MDBListGroupItem,
  MDBAnimation
} from "mdbreact";

import TagName from "~/components/common/atoms/TagName";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import styles from "./style.module.scss";
import imgNew1 from "~/assets/img/desktop/common/new1.jpg";
import imgNew2 from "~/assets/img/desktop/common/new2.jpg";
import imgNew3 from "~/assets/img/desktop/common/new3.jpg";
const AdvanceMedPro = () => {
  return (
    <MDBAnimation type="fadeIn" className={styles.advance_medpro}>
      <div className={styles.advance_medpro_1}>
        <MDBContainer>
          <MDBRow>
            <MDBCol size={12}>
              <div className={styles.about_advance_medpro}>
                <div className={styles.about_item}>
                  <div className={styles.about_item_1}>
                    <div>
                      <TagName element="span" className={["about_medpro"]}>
                        Giới thiệu
                      </TagName>
                    </div>
                    <h3>MEDPRO - Giải pháp tiếp cận y tế thông minh</h3>
                  </div>
                  <div className={styles.about_item_2}>
                    <strong>Medpro</strong> là giải pháp nhằm kết nối bệnh viện
                    với người dùng có nhu cầu đăng ký khám bệnh có thể thực hiện
                    việc đăng ký khám bệnh hoàn toàn trực tuyến ở mọi lúc mọi
                    nơi, mà không cần phải đến bệnh viện đề xếp hàng và chờ đợi.
                    Giúp bệnh nhân có kế hoạch khám chữa bệnh chủ động, rút ngắn
                    thời gian chờ đợi, góp phần nâng cao sức khoẻ bệnh nhân.
                  </div>
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
      <div className={styles.advance_medpro_2}>
        <MDBContainer>
          <MDBRow>
            <MDBCol size={12}>
              <div className={styles.box_advance_medpro}>
                <MDBListGroup className={styles.list_group}>
                  <MDBListGroupItem>
                    <div className={styles.img}>
                      {" "}
                      <LazyLoad height={230}>
                        <img src={imgNew1} alt="" />
                      </LazyLoad>
                    </div>
                    <div className={styles.content}>
                      <h4>
                        <Link to="/">Đặt khám nhanh chóng</Link>
                      </h4>
                      <p>
                        Bệnh nhân chủ động chọn thông tin đặt khám (ngày khám và
                        giờ khám)
                      </p>
                    </div>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <div className={styles.img}>
                      <LazyLoad height={230}>
                        <img src={imgNew2} alt="" />
                      </LazyLoad>
                    </div>
                    <div className={styles.content}>
                      <h4>
                        <Link to="/">Thanh toán dễ dàng</Link>
                      </h4>
                      <p>
                        Người dùng chọn và thực hiện thanh toán trên phần mềm
                      </p>
                    </div>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <div className={styles.img}>
                      <LazyLoad height={230}>
                        <img src={imgNew3} alt="" />
                      </LazyLoad>
                    </div>
                    <div className={styles.content}>
                      <h4>
                        <Link to="/">Nhận phiếu trực tuyến</Link>
                      </h4>
                      <p>
                        Bệnh nhân sẽ nhận phiếu khám trực tuyến ngay trên phần
                        mềm
                      </p>
                    </div>
                  </MDBListGroupItem>
                </MDBListGroup>
                <p className={styles.box_advance_medpro_p}>
                  Tìm hiểu thêm về quy trình{" "}
                  <a className={styles.dot} href="/quy-trinh">
                    đăng ký khám bệnh
                  </a>
                </p>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    </MDBAnimation>
  );
};

export default AdvanceMedPro;
